export default __webpack_public_path__ + "static/media/img_parcours_mer_logo_white.b04d2077.svg";